import { useParams } from 'react-router-dom';

import { useSelectedContract } from '@/hooks/api/use-contracts';
import { useFleetVehicle } from '@/hooks/api/use-fleet';
import { getContractGarantiesOptions } from '@/lib/contracts';

/** Garantie lue par la déclaration (`code`, `code_famille`). */
export interface DeclarationGarantie {
    code?: unknown;
    code_famille?: unknown;
    [key: string]: unknown;
}

/**
 * Véhicule de flotte sur lequel porte la déclaration, pris dans l'URL
 * (`/mes-sinistres/je-declare-un-sinistre/contrat/:contractId/vehicule/:vehiculeId`) comme le faisait l'espace pro :
 * Belair attend le sinistre sur l'adhésion du véhicule, pas sur l'adhésion principale de la flotte.
 * Hors flotte, rien n'est lu.
 */
export const useDeclarationFleetVehicle = () => {
    const contract = useSelectedContract();
    const { vehiculeId: param } = useParams();
    const isFleet = !!contract?.flotte;
    /* L'adhésion entre dans le chemin de l'appel : seul un numéro est accepté. */
    const vehiculeId = isFleet && param && /^\d+$/.test(param) ? param : undefined;
    const query = useFleetVehicle(contract?.id ?? '', vehiculeId ?? '', !!vehiculeId);

    return { isFleet, vehiculeId, query };
};

/**
 * Garanties prises en compte par la déclaration : celles du véhicule de flotte déclaré pour un
 * contrat flotte, celles du contrat sinon.
 */
export const useDeclarationGaranties = (): DeclarationGarantie[] | undefined => {
    const contract = useSelectedContract();
    const { isFleet, query } = useDeclarationFleetVehicle();

    return isFleet ? query.data?.garanties : getContractGarantiesOptions(contract);
};
